import { VectorRender } from '../../renders/Render';
import { error } from "../../utils/utils";
import { StaticVectorImageRender } from "../../renders/StaticVectorImageRender";
import { VectorLabel } from "../../renders/VectorLabel";
/**
 * @alias sGis.painter.domPainter.Canvas
 * @ignore
 */
export class Canvas {
    constructor(canvasNode) {
        if (canvasNode) {
            this._canvasNode = canvasNode;
            this._ctx = this._canvasNode.getContext('2d');
        }
        else {
            this._createNode();
        }
    }
    _createNode() {
        this._canvasNode = document.createElement('canvas');
        this._canvasNode.style.pointerEvents = 'none';
        this._ctx = this._canvasNode.getContext('2d');
    }
    reset(bbox, resolution, width, height) {
        this._ctx.clearRect(0, 0, this._canvasNode.width, this._canvasNode.height);
        this._canvasNode.width = width;
        this._canvasNode.height = height;
        this._isEmpty = true;
        this.bbox = bbox;
    }
    get width() { return this._canvasNode.width; }
    get height() { return this._canvasNode.height; }
    draw(render, domPainter) {
        if (render instanceof VectorRender) {
            render.drawOnCanvas(this._ctx, domPainter);
        }
        else if (render instanceof StaticVectorImageRender || render instanceof VectorLabel) {
            this._drawImage(render, domPainter);
        }
        else {
            error('Unknown vector geometry type.');
        }
        this._isEmpty = false;
    }
    setIndex(index) {
        if (index !== this.zIndex) {
            this._canvasNode.style.zIndex = index;
            this.zIndex = index;
        }
    }
    _drawImage(render, domPainter) {
        let x, y;
        if (render.mapPosition && domPainter) {
            [x, y] = render.mapPosition;
            const xScale = domPainter.getXScale();
            const yScale = domPainter.getYScale();
            x = Math.round(xScale(x));
            y = domPainter.height - Math.round(yScale(y));
        }
        else {
            [x, y] = render.position;
        }
        x = Math.round(x);
        y = Math.round(y);
        this._ctx.translate(x, y);
        if (!(render instanceof VectorLabel)) {
            this._ctx.rotate(render.angle);
        }
        let opacity = !(render instanceof VectorLabel) ? render.opacity : 1;
        if (opacity !== 1)
            this._ctx.globalAlpha = opacity;
        this._ctx.drawImage(render.node, render.offset[0], render.offset[1], render.width, render.height);
        if (opacity !== 1)
            this._ctx.globalAlpha = 1;
        if (!(render instanceof VectorLabel)) {
            this._ctx.rotate(-render.angle);
        }
        this._ctx.translate(-x, -y);
    }
    get isEmpty() { return this._isEmpty; }
    get node() { return this._canvasNode; }
}
